/* eslint-disable @typescript-eslint/no-explicit-any */
const validateForm = (formSchema: any, formValues: any) => {
  const isFormValid = formSchema.isValid(formValues, { abortEarly: false })
  return isFormValid
}

export default validateForm
